import React from 'react';

const BookmarkIcon = ({ className, style }) => (
    <svg className={className} style={style} width="13" height="21" viewBox="0 0 13 21" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path id="Path 252" d="M12.5002 19.6676L6.49892 16.8895L0.500244 19.6676V1.00098H12.5002V19.6676Z" stroke="currentColor"/>
    </svg>
);

export default BookmarkIcon;
